import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import CycodeCredentialsForm from "./CycodeCredentialsForm";
import CycodeConfigListing from "./CycodeConfigListing";

export default function CycodePullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={CycodeCredentialsForm}
      PullConfigListingView={CycodeConfigListing}
    />
  );
}
